import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { FbmOrdersService } from 'src/app/modules/fbm-orders/fbm-orders.service';

@Component({
  selector: 'app-batch-pick-cell-renderer',
  templateUrl: './batch-pick-cell-renderer.component.html',
  styleUrls: ["./batch-pick-cell-renderer.component.scss"]
})
export class BatchPickCellRendererComponent implements OnInit,OnDestroy {
  params;
  pickValue;
  pick = new FormControl(1,Validators.required);
  selectedQty:number;
  private destroy$ = new Subject<void>();

  constructor(
    private fbmOrderService: FbmOrdersService,
    private snackBar: MatSnackBar
  ) { }

  agInit(params: any): void {
    this.params = params;
    this.fbmOrderService.isDisabaleSubmit.subscribe((res)=>{
    })
  }

  restrictMinus(event) {
    if (event.which === 45) return false;
  }

  ngOnInit(): void {   
    if(this.params.isPickInput){
      this.pick.setValue(this.params.data.QtyFound);
    }
   
  }

  submitPick() {
    const payload = {
          itemId: this.params.data.ItemId,
          pickingBatchId: this.params.data.pickingBatchId,
          locationId: this.params.data.LocationId,
          qtyFound: this.params.data.QtyFound,
          qty: this.params.data.QtyToPick
    }
    this.fbmOrderService.savePickingItems(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 4000,
            horizontalPosition: "center",
            data: {
              title: "Changes saved successfully",
              action: "Dismiss",
              type: "success",
            },
          });
          this.params.api.refreshServerSide();
      },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err.error.error,
            action: "Dismiss",
            type: "error",
          },
        });
      }
    });
  }

  onChange(event): void {
    this.params.data.QtyFound = Number(event.target.value);
    this.params.callbackFunction(this.params);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
